import type { HTMLAttributes } from "react";
import { cn } from "@/lib/utils";

export function Badge({ tone = "neutral", className, ...props }: HTMLAttributes<HTMLSpanElement> & { tone?: "neutral" | "blue" | "orange" | "green" | "red" }) {
  return <span className={cn("badge", `badge--${tone}`, className)} {...props} />;
}
